/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca, Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import { slug } from '../../common';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.settings`;
export default function () {
  // NotificationGrid only reaches the forum bundle through the lazily-loaded SettingsPage
  // chunk, so a synchronous import of it resolves to undefined — patch it by path instead.
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    // With notifications off the server registers no preference for the type, so a toggle would be accepted and dropped.
    if (app.forum.attribute(`${slug}.gamification.enabled`) && app.forum.attribute(`${slug}.levels.enabled`) && app.forum.attribute(`${slug}.enable-notifications`)) {
      items.add('levelChanged', {
        name: 'levelChanged',
        icon: 'fas fa-diamond',
        label: t(`${prfx}.notify_level_changed`)
      });
    }
  });
}
flarum.reg.add('glowingblue-gamilytics', 'forum/levels', );